import { Link } from "react-router-dom";
import { ArrowUp, KeyRound } from "lucide-react";
import { Monogram } from "@/components/Monogram";

export const Footer = () => (
  <footer className="border-t border-black/8 px-6 py-10 lg:px-16">
    <div className="flex flex-col items-center justify-between gap-6 sm:flex-row">
      <div className="flex items-center gap-3 text-zinc-500">
        <Monogram size={26} />
        <span className="font-mono text-[10px] uppercase tracking-[0.3em]">© MMXXVI Roy A Smith</span>
      </div>
      <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-400">royasmith.com</span>
      <div className="flex items-center gap-6">
        <Link
          data-testid="settings-link-footer"
          to="/settings"
          title="Owner settings"
          className="text-zinc-300 transition-colors hover:text-[#9A7B24]"
        >
          <KeyRound size={15} />
        </Link>
        <button
          data-testid="back-to-top-btn"
          onClick={() => (window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }))}
          className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 transition-colors hover:text-[#9A7B24]"
        >
          Top <ArrowUp size={13} />
        </button>
      </div>
    </div>
  </footer>
);
